/**
 * 缓存 class
 */
import sessionStorage from '../sessionStorage';
import { CACHEKEY, CACHEMAXSIZE } from '../common/config';
import EventEmitter from '../events'

class MemoryCache extends EventEmitter {
  memoryCaches = new Map();
  // maxSize
  maxSize = CACHEMAXSIZE
  // 事件中心
  // eventCenter = new EventEmitter()
  /**
   * 设置缓存
   * @param key
   * @param value
   * @returns
   */
  set (key: string, value: any) {
    if (this.memoryCaches.has(key)) {
      this.memoryCaches.delete(key);
    }
    if (this.size() >= this.maxSize) {
      // 如果当前缓存的map 的长度超出限制，则删除最前面的一个映射keys.next().value 可以拿到第一个映射的 key
      const nextKey = this.memoryCaches.keys().next().value;
      const nextValue = this.memoryCaches.get(nextKey);
      // 降级到session 缓存
      sessionStorage.setItem(
        this.getCacheKey(nextKey),
        JSON.stringify(nextValue)
      );
      this.memoryCaches.delete(nextKey);
    }
    // 老value
    const oldValue:any = this.get(key)
    // 设置新value
    this.memoryCaches.set(key, value);
    this.emit(key, value, oldValue)
  }

  /**
   * 获取缓存对应的值
   * @param key
   * @returns
   */
  get (key: string): any {
    // 如果当前有值，删除后，更新
    if (this.memoryCaches.has(key)) {
      const value = this.memoryCaches.get(key);
      this.memoryCaches.delete(key);
      this.memoryCaches.set(key, value);
      return value;
    } else {
      // 降级到session 读取
      const value = sessionStorage.getItem(this.getCacheKey(key));
      if (value) {
        return JSON.parse(value);
      } else {
        return null;
      }
    }
  }

  /**
   * 删除缓存内容
   * @param key key
   */
  remove (key: string) {
    // 老value
    const oldValue:any = this.get(key)
    // 设置新value
    this.emit(key, null, oldValue)
    this.memoryCaches.delete(key);
    sessionStorage.removeItem(this.getCacheKey(key));
  }

  /**
   * 清空缓存
   */
  clear (): void {
    const allKeys:string[] = []
    this.memoryCaches.forEach((_:any, key:string) => {
      allKeys.push(key)
    })
    // 删除降级缓存里面的数据
    Object.keys(window.sessionStorage).forEach(key => {
      if (key.indexOf(CACHEKEY) > -1) {
        allKeys.push(key.replace(CACHEKEY + '_', ''))
      }
    })
    allKeys.forEach((item:string) => {
      this.remove(item)
    })
    // this.memoryCaches.clear();
  }

  config ({ maxSize = CACHEMAXSIZE }: any = {}): void {
    this.maxSize = maxSize
  }

  /**
   *
   * @param key
   * @returns
   */
  getCacheKey (key: string): string {
    return `${CACHEKEY}_${key}`;
  }

  /**
   * 获取缓存数量
   * @returns 缓存数量
   */
  size (): number {
    return this.memoryCaches.size;
  }
}

export default new MemoryCache();
